import React from 'react';
import cn from 'classnames';
import propTypes from 'prop-types';

export default function ListTabArrow({ handleListDropDownClick, listsDropDownOpen }) {
  return (
    <svg
      className={cn('down-arrow', listsDropDownOpen ? 'list-dropdown-open' : '')}
      onClick={() => handleListDropDownClick()}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="20px"
      height="20px"
      viewBox="0 0 20 20"
      style={{ enableBackground: 'new 0 0 20 20' }}
      xmlSpace="preserve"
    >
      <g>
        <polygon points="2,10 18,10 10,18 	" />
        <path d="M10,18.7L0.8,9.5h18.4L10,18.7z M3.2,10.5l6.8,6.8l6.8-6.8H3.2z" />
      </g>
      <path className="st0" d="M8.1,6.2" />
    </svg>
  );
}
ListTabArrow.propTypes = {
  listsDropDownOpen: propTypes.bool,
  handleListDropDownClick: propTypes.func,
};
